import React from "react";
import { useNavigate } from "react-router-dom";

export function BillingCancelled() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center surface-page px-4">
      <div className="max-w-md w-full surface-card rounded-2xl shadow-xl p-8 text-center">
        {/* Cancel Icon */}
        <div className="mx-auto w-16 h-16 bg-gray-100 dark:bg-slate-800 rounded-full flex items-center justify-center mb-4">
          <svg className="w-10 h-10 text-gray-600 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>

        {/* Title */}
        <h1 className="text-3xl font-bold text-gray-900 dark:text-gray-100 mb-2">
          Payment Cancelled
        </h1>

        {/* Message */}
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          No worries! Your payment was cancelled and you haven't been charged.
        </p>

        <p className="text-gray-500 dark:text-gray-400 mb-8">
          You can upgrade to Elite anytime to unlock premium features like seeing who liked you, more likes, and more.
        </p>

        {/* Action Buttons */}
        <div className="space-y-3">
          <button
            onClick={() => navigate("/dashboard")}
            className="w-full bg-gradient-to-r from-rose-600 to-pink-600 text-white font-semibold py-3 px-6 rounded-full hover:from-rose-700 hover:to-pink-700 transition-all duration-200 shadow-md hover:shadow-lg"
          >
            Back to Dashboard
          </button>
          
          <button
            onClick={() => navigate("/upgrade")}
            className="w-full bg-transparent text-rose-600 dark:text-rose-400 font-semibold py-3 px-6 rounded-full border-2 border-rose-600 dark:border-rose-500 hover:bg-rose-50 dark:hover:bg-rose-900/20 transition-all duration-200"
          >
            View Elite Benefits
          </button>
        </div>
      </div>
    </div>
  );
}
